import { createAsyncAction } from 'services/actionConfigs';
import { PREFIX_ACTIONS } from './constants';
import { IActFetchSummaryReportParams } from './types/report';
const getSalonSummary = createAsyncAction<IActFetchSummaryReportParams>(PREFIX_ACTIONS + 'getSalonSummary');
const reportActions = {
  getSalonSummary,
};

export default reportActions;
